import { WebPlugin } from '@capacitor/core';
export class ExportBase64ImageToGalleryWeb extends WebPlugin {
    async checkPermissions() {
        return new Promise((resolve, _reject) => resolve);
    }
    async requestPermissions() {
        return new Promise((resolve, _reject) => resolve);
    }
    async exportImageToGallery(options) {
        console.log('exportImageToGallery', options);
        return new Promise((resolve, _reject) => resolve);
    }
}
//# sourceMappingURL=web.js.map